export const administrationAccountsSiteLocationQualityManagers = {
    template: require('./administration-accounts-site-location-quality-managers.html'),
    controller: 'AdministrationAccountsSiteLocationQualityManagersController'
};
